<template>
  <div>
    <Header />
    <div class="content" style="padding-top: 2rem; text-align: center">
      <img src="assets/img/logo.svg" alt style="width: 80%; max-width: 40rem; " />
      <img src="/assets/img/other/sam.png" class="sam" />
      <p>
        Ahoj,
      </p>
      <p>
        moje jméno je Šimon Klíma a společně s bráchou Adamem provozujeme létající pivovar HoppyHedgehog. K vaření nás
        přivedla pochopitelně láska k pivu, chuť vlastnoručně si vyzkoušet jeho výrobu a postupem času tenhle koníček
        vyrostl v pořádného koně. 🐎
      </p>
      <p>
        O Vánocích roku 2012 vznikla naše první várka. Ve skromných domácích podmínkách jsme během let navařili přes 50
        různých várek piva, během nichž jsme nabrali potřebné znalosti a zkušenosti. Naše piva začala získávat pochvalné
        ohlasy, nejdříve od rodiny, přátel a zanedlouho i od prvních zákazníků. Od roku 2020 fungujeme jako létající
        pivovar, na konci loňského roku vznikla již zmiňovaná značka HoppyHedgehog.
      </p>
      <p>
        Momentálně hledáme dalšího nadšence (parťáka do podnikání), který se rád vrhne do světa minipivovarů a zastoupil
        by roli obchodníka. Člověka, který bude s nadšením vyhledávat nové zákazníky, udržovat kontakt se stávajícími a
        obecně šířit povědomí o našem pivovaru. Zároveň ale bude ochotný si v případě potřeby „ušpinit ruce“ a pomoct
        nám, ať už při nákupu surovin, vaření nebo stáčení piva.
      </p>
      <p>
        Za dobu, co se v tomhle odvětví pohybujeme jsme poznali hromadu fajn lidí, a proto si myslím, že se rozhodně
        není čeho bát. A navíc, pivo je prostě „cool“!
      </p>
      <p>
        Dej Bůh štěstí 🍺🦔.
      </p>
      <p>
        Praxe pro nás není důležitá, důležitý je zápal pro věc, ale potřebujeme aby si byl/a:
      </p>
      <ul>
        <li>extrovert, který se nebojí oslovit zákazníky (ať už osobně či telefonicky),</li>
        <li>organizovaný a odpovědný,</li>
        <li>uměl/a vyhledávat informace (tím pádem i nové příležitosti),</li>
        <li>měl/a zájem o pivo a alespoň základní orientaci v pivních stylech (v ideálním případě domovarník)</li>
      </ul>

      <p>
        Co za oplátku nabízíme?
      </p>

      <ul>
        <li>Zapojení do fungování začínající firmy</li>
        <li>Vhled do fungování pivovarské technologie a vše s tím spojené</li>
        <li>Možnost podílet se určení směru našeho pivovaru</li>
        <li>Odměňování formou provizního systému</li>
        <li>V případě vzájemné dlouhodobé spokojenosti jsme připraveni nabídnout rovnocenný podíl ve společnosti</li>
        <li>Velkou slevu na pivo ;-)</li>
      </ul>

      <p>
        V případě zájmu nás můžete kontaktovat telefonicky nebo emailem. <br />
        Tel.: + 420 724 044 780 <br />
        Email: simon.klima@hoppyhedgehog.cz<br />
      </p>
    </div>
  </div>
</template>

<script>
import Header from "../../templates/Header";
export default {
  name: "Sales",
  components: { Header },
  data: () => ({
    item: { variants: [] },
  }),

  metaInfo() {
    return {
      title: `Obchodník`,
      meta: [
        { vmid: "og:image", property: "og:image", content: "https://hoppyhedgehog.cz/assets/img/other/sam.png" },
        { vmid: "og:title", property: "og:title", content: "HoppyHedgehog hledá obchodníka" },
        { vmid: "og:url", property: "og:url", content: "https://hoppyhedgehog.cz/obchodnik" },
      ],
    };
  },
};
</script>
<style scoped>
p {
  text-align: justify;
  width: 100%;
}

ul {
  text-align: left;
}
.content {
  margin: auto;
  max-width: 40rem;
}

.sam {
  -webkit-mask-image: -webkit-gradient(linear, left top, left bottom, from(rgba(0, 0, 0, 1)), to(rgba(0, 0, 0, 0)));
  mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 1), 80%, rgba(0, 0, 0, 0));

  margin-top: 3rem;
  margin-bottom: 3rem;
  min-width: 150px;
  width: 70%;
}
</style>
